import { useMemo, useCallback } from 'react';
import { PRODUCTS, THREEBTYPES } from 'constants/constants';
import useLayoutController from 'components/Stepper/RouteBasedStepper/useLayoutController';
import { useCreateProposal } from '../CreateProposalManager';

const useProposalProductSelection3b = () => {
    const {
        selectedProductId,
        setSelectedProductOfferId,
        products: productOptions,
        selectedProposalOwner,
    } = useCreateProposal();

    const productOptions3B = useMemo(
        () => productOptions
            ?.filter((f) => f.settings.productKey === PRODUCTS.bbb && ![THREEBTYPES.pk, THREEBTYPES.azpNeuSB].includes(f.externalId))
            ?.map((product) => ({
                id: product?.externalId === THREEBTYPES.azpNeu ? 555555 : product?.id,
                name: product?.externalId === THREEBTYPES.azpNeu ? 'AZP' : product?.name,
                externalId: product?.externalId,
                isEnabled: true,
                description: product?.externalId === THREEBTYPES.azpNeu ? 'Asset Zurich Portfolio' : (product?.description || ''),
            })),
        [
            productOptions,
        ],
    );

    const onContinue = useCallback(async () => {
        // sdf
        setStepComplete(true);
    }, []);

    const { setStepComplete } = useLayoutController({
        callbackOnContinue: onContinue,
        isContinueDisabled: false,
        isBackDisabled: false,
        reSubscriptionStates: [],
    });

    return { productOffers: productOptions3B, selectProductOfferId: selectedProductId, onSelectedProductOfferChange: setSelectedProductOfferId, selectedProposalOwner };
};

export default useProposalProductSelection3b;
